// src/reducers/selectedService.ts
import { SET_SELECTED_SERVICE } from "src/actions/SelectedService";

interface ISelectedServiceState {
  data: any | null;
  columns: { key: string; width: number }[];
}

const initial: ISelectedServiceState = { data: null, columns: [] };

export default function selectedServiceReducer(
  state = initial,
  action: any
) {
  switch (action.type) {
    case SET_SELECTED_SERVICE:
      return {
        data: action.payload.data,
        columns: action.payload.columns,   // ← teraz tablica obiektów
      };
    default:
      return state;
  }
}
